import { Injector } from "@angular/core";
import { WorkplaceActionHandlerBase } from "../../../../../../components/common/grid-base/actions/workplace-action-handler-base";
import { WorkplaceBase } from "../../../../../../components/common/workplace-base/workplace-base";

/**
 * Handles VE saving
 */
export class ValuationEventSavedWorkplaceActionHandler extends WorkplaceActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workplace: WorkplaceBase) {
    super(injector, workplace, 'valuationProjectPortfolioItemSaved');
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    if (this.workplace.searchMode != 'valuationPortfolio') {
      this.workplace.selectedTab = "#tabValuationPortfolio";
      this.eventBus.broadcastEvent("toolbarSetArea", this.workplace.searchMode);
    }
  }
}
